import React from "react";
import ListCompetitions from "../AdminDashboard/ListCompetitions";

export default function UserDashbord() {
  return (
    <div>
      <ListCompetitions userType="user" />
    </div>
  );
}
